<template>
  <div :class="[`${name}`, { video: hasVideo }]">
    <a-video v-if="hasVideo" :cms="cms" :class="`${name}__video`" />
    <a-image
      v-if="!hasVideo && imageSrc"
      :cms="cms"
      :layout="layout"
      :class="[
        `${name}__image`,
        { [`${name}__image--desktop`]: imageMobileSrc },
      ]"
    />
    <a-image
      v-if="!hasVideo && imageMobileSrc"
      :src="imageMobileSrc"
      :focus="(cms.image_mobile || {}).focus"
      :layout="layout"
      :class="[`${name}__image`, `${name}__image--mobile`]"
    />
  </div>
</template>

<script>
import data from '~/components/molecules/m-media/m-media.data'
import Colors from '~/mixins/colors'
import AImage from '~/components/atoms/a-images/a-image-v2'
import AVideo from '~/components/atoms/a-video/a-video'
export default {
  components: { AImage, AVideo },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return process.env.NODE_ENV === 'development' ? data : {}
      },
    },
    image: {
      type: String,
      default() {
        return ''
      },
    },
    imageMobile: {
      type: String,
      default() {
        return ''
      },
    },
    layout: {
      type: Array,
      default() {
        return [
          { size: 0, bound: 667, ratio: [360, 255] },
          { size: 1, bound: 768, ratio: [680, 500] },
          { size: 2, bound: 992, ratio: [680, 500] },
          { size: 3, bound: 1200, ratio: [680, 500] },
          { size: 4, bound: 1440, ratio: [680, 500] },
        ]
      },
    },
  },
  data() {
    return {
      name: 'm-media',
    }
  },
  computed: {
    hasVideo() {
      const check =
        (this.cms.video || {}).filename ||
        (this.cms.youtube || {}).vimeo_raw ||
        (this.cms.vimeo || {}).vimeo_raw ||
        false
      this.$emit('has-video', check)
      return check
    },
    imageSrc() {
      return (this.cms.image || {}).filename || this.cms.image || this.image
    },
    imageMobileSrc() {
      return (
        (this.cms.image_small || {}).filename ||
        this.cms.image_small ||
        this.imageMobile
      )
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || 'inherit',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || 'inherit'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || 'inherit'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || 'inherit'
        ),
        '--filter': this.cms.filter || null,
        '--spacing-top': this.cms.spacing_top || 0,
        '--spacing-bottom': this.cms.spacing_bottom || 0,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-media {
  height: 100%;

  ::v-deep a,
  ::v-deep .a-cta,
  ::v-deep button {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep img {
    filter: var(--filter);
  }

  &__image--desktop {
    display: none;
  }
}

@include media-breakpoint-up(sm) {
  .m-media {
    &__image--desktop {
      display: block;
    }
    &__image--mobile {
      display: none;
    }
  }
}
</style>
